<div [formGroup]="editForm" class="multi-column-layout">

    <div class="flex-vertical col-box">

        <input type="hidden" name="id" formControlName="id">    
        
        <mat-form-field appearance="outline" class="flex-fill">
            <mat-label>{{ 'REVIEW_PERIOD_EDIT.TYPE' | translate }}</mat-label>
            <mat-select formControlName="reviewType" disableOptionCentering class="drop-fix" (selectionChange)="reviewTypeChanged()" required>
                <mat-option *ngFor="let item of reviewTypes" [value]="item.id">{{ item.translateKey | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
       
        <mat-form-field appearance="outline" class="flex-fill" *ngIf="isPanorama(selectedReviewType)">
            <mat-label>{{ 'REVIEW_PERIOD_EDIT.PREVIOUS_EVALUATION' | translate }}</mat-label>
            <mat-select formControlName="previousId" disableOptionCentering class="drop-fix" [title]="'REVIEW_PERIOD_EDIT.PREVIOUS_EVALUATION_TOOLTIP' | translate">
                <mat-option *ngFor="let item of prevReviewPeriodList" [value]="item.id">{{ item | periodName }}</mat-option>
            </mat-select>
            <mat-error msg></mat-error>
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ 'REVIEW_PERIOD_EDIT.VALIDITY_PERIOD' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate formControlName="startDate" [placeholder]="'REVIEW_PERIOD_EDIT.START' | translate">
              <input matEndDate formControlName="endDate" [placeholder]="'REVIEW_PERIOD_EDIT.END' | translate">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    
        <mat-form-field appearance="outline" [title]="'REVIEW_PERIOD_EDIT.NAME_HU' | translate">
            <mat-label>{{ 'REVIEW_PERIOD_EDIT.NAME_HU' | translate }}</mat-label>
            <input matInput type="text" name="nameHu" formControlName="nameHu" required>
        </mat-form-field>

        <mat-form-field appearance="outline" [title]="'REVIEW_PERIOD_EDIT.NAME_EN' | translate">
            <mat-label>{{ 'REVIEW_PERIOD_EDIT.NAME_EN' | translate }}</mat-label>
            <input matInput type="text" name="nameEn" formControlName="nameEn" required>
        </mat-form-field>
    
        <!-- <mat-form-field appearance="outline">
            <mat-label>Leírás</mat-label>
            <input matInput type="text" name="description" formControlName="description">
        </mat-form-field>
    
        <mat-form-field appearance="outline" class="width-max hidden-print">
            <mat-label>Instrukciók</mat-label>
            <textarea matInput name="instructions" formControlName="instructions" autocomplete="off"></textarea>
        </mat-form-field> -->
    
        <div *ngIf="isPanorama(selectedReviewType)" class="settings-panel">
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.TYPE_SETTINGS' | translate }}
                <ng-container *ngIf="!allowSettingsEdit">
                    <ng-container *ngTemplateOutlet="reviewInProgressInfo"></ng-container>
                </ng-container>
            </div>
            <div class="panel-content simple-border">
                <mat-checkbox class="multiline" formControlName="isPositionBasedAssessment" [disableControl]="!allowSettingsEdit" (change)="changeIsPositionBasedAssessment($event)">{{ 'REVIEW_PERIOD_EDIT.PANORAMA_COMPETENCY_ASSESSMENT' | translate }}</mat-checkbox>
                <mat-checkbox class="multiline" formControlName="isGoalsEnabled" [disableControl]="!allowSettingsEdit" (change)="changeIsGoals($event)">{{ 'REVIEW_PERIOD_EDIT.PANORAMA_GOAL_SETTING' | translate }}</mat-checkbox>
                <mat-checkbox class="multiline" formControlName="isSpecialQuestionSetBasedAssessment" [disableControl]="!allowSettingsEdit" (change)="changeIsAura($event)">{{ 'REVIEW_PERIOD_EDIT.AURA' | translate }}</mat-checkbox>
            </div>
        </div>
    
        <div *ngIf="isPanorama(selectedReviewType) && (isPositionBasedAssessment || isAura || isGoalsEnabled)" class="settings-panel">
            <div class="panel-content">
                <div *ngIf="isPositionBasedAssessment || isAura">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{ 'REVIEW_PERIOD_EDIT.PANORAMA_AURA_COMPETENCY_START' | translate }}</mat-label>
                        <mat-date-range-input [rangePicker]="pickerPanorama">
                          <input matStartDate formControlName="panoramaAuraStartDate" [placeholder]="'REVIEW_PERIOD_EDIT.START' | translate">
                          <input matEndDate formControlName="panoramaAuraEndDate" [placeholder]="'REVIEW_PERIOD_EDIT.END' | translate">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="pickerPanorama"></mat-datepicker-toggle>
                        <mat-date-range-picker #pickerPanorama></mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div *ngIf="isGoalsEnabled">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{ 'REVIEW_PERIOD_EDIT.PANORAMA_GOAL_SETTING_OPEN' | translate }}</mat-label>
                        <mat-date-range-input [rangePicker]="pickerGoals">
                          <input matStartDate formControlName="goalsStartDate" [placeholder]="'REVIEW_PERIOD_EDIT.START' | translate">
                          <input matEndDate formControlName="goalsEndDate" [placeholder]="'REVIEW_PERIOD_EDIT.END' | translate">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="pickerGoals"></mat-datepicker-toggle>
                        <mat-date-range-picker #pickerGoals></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    
    </div>

    <div class="flex-vertical col-box">
        <div *ngIf="assessmentActions && assessmentActions.showGeneralSettings" class="settings-panel">
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.GENERAL_SETTINGS' | translate }}
            </div>
            <div class="panel-content simple-border">
                <mat-checkbox class="multiline" formControlName="isAutomaticReminderEnabled">{{ 'REVIEW_PERIOD_EDIT.AUTOMATIC_REMINDER' | translate }}</mat-checkbox>
                <mat-checkbox class="multiline" formControlName="isFreeTextAssessmentAllowed" *ngIf="assessmentActions.isFreeTextAssessmentAllowed" [disableControl]="!allowSettingsEdit">{{ 'REVIEW_PERIOD_EDIT.FREE_TEXT_FEEDBACK_OPTION' | translate }}</mat-checkbox>
                <mat-checkbox class="multiline with-icon" formControlName="copyEmployees" *ngIf="assessmentActions.copyEmployees && addMode" [disableControl]="!allowSettingsEdit">
                    {{ 'REVIEW_PERIOD_EDIT.AUTOMATIC_EMPLOYEE_ADDITION' | translate }} <mat-icon class="info" [matTooltip]="'REVIEW_PERIOD_EDIT.AUTOMATIC_EMPLOYEE_ADDITION_TOOLTIP' | translate">info</mat-icon></mat-checkbox>
                <!-- <mat-checkbox class="multiline" formControlName="updateRpe" *ngIf="assessmentActions.updateRpe && !addMode" [disableControl]="!allowSettingsEdit">{{ 'REVIEW_PERIOD_EDIT.UPDATE_PEER_EVALUATION' | translate }}</mat-checkbox> -->
            </div>
        </div>
    </div>

    <div class="flex-vertical col-box">
        <div *ngIf="isPanorama(selectedReviewType) && isPositionBasedAssessment" class="settings-panel questionsets">
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.QUESTIONNAIRES' | translate }}
                <ng-container *ngIf="!allowSettingsEdit">
                    <ng-container *ngTemplateOutlet="reviewInProgressInfo"></ng-container>
                </ng-container>
            </div>
            <div class="panel-content simple-border scroll-box max-height-300">
                <ul>
                    <li *ngFor="let child of displaySelectedQuestionSets; let i = index">
                        <div>
                            <strong>{{ getQuestionSetName(child) }}</strong> <span class="desc">{{ getQuestionSetDesc(child) }}</span>
                        </div>
                        <div class="sub-text">{{ child.questionSetCreatedOn | localizedDate }}</div>
                    </li>
                </ul>
                <!-- <ng-container >
                    <ng-container [formGroupName]="i">
                        <mat-checkbox class="multiline" formControlName="isSelected" [ngClass]="{'subQuestionSet': isSubQuestionSet(child.value)}" [disableControl]="!allowSettingsEdit"></mat-checkbox>
                    </ng-container>
    
                </ng-container> -->
               
            </div>
        </div>

        <div *ngIf="assessmentActions && assessmentActions.isPositionProfileSettingsAllowed" class="settings-panel" formGroupName="reviewPeriodPositionProfileSettings">
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.POSITION_PROFILE_WEIGHTS' | translate }}</div>
            <div class="panel-content goalsettings p-top-only">        
                <mat-form-field appearance="outline" [title]="'REVIEW_PERIOD_EDIT.NORMAL_FACTOR_WEIGHT' | translate">
                    <mat-label>{{ 'REVIEW_PERIOD_EDIT.NORMAL_FACTOR_WEIGHT' | translate }}</mat-label>
                    <input matInput type="number" formControlName="normalFactorWeight" required>
                    <mat-icon matSuffix [title]="getFieldErrorText('reviewPeriodPositionProfileSettings.normalFactorWeight')" class="text-danger" *ngIf="editForm.get('reviewPeriodPositionProfileSettings.normalFactorWeight').invalid && (editForm.get('reviewPeriodPositionProfileSettings.normalFactorWeight').dirty || editForm.get('reviewPeriodPositionProfileSettings.normalFactorWeight').touched)">error</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" [title]="'REVIEW_PERIOD_EDIT.ADDITIONAL_FACTOR_WEIGHT' | translate">
                    <mat-label>{{ 'REVIEW_PERIOD_EDIT.ADDITIONAL_FACTOR_WEIGHT' | translate }}</mat-label>
                    <input matInput type="number" formControlName="additionalFactorWeight" required>
                    <mat-icon matSuffix [title]="getFieldErrorText('reviewPeriodPositionProfileSettings.additionalFactorWeight')" class="text-danger" *ngIf="editForm.get('reviewPeriodPositionProfileSettings.additionalFactorWeight').invalid && (editForm.get('reviewPeriodPositionProfileSettings.additionalFactorWeight').dirty || editForm.get('reviewPeriodPositionProfileSettings.additionalFactorWeight').touched)">error</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" [title]="'POSITION.KEY_FACTOR' | translate">
                    <mat-label>{{ 'POSITION.KEY_FACTOR' | translate }}</mat-label>
                    <input matInput type="number" formControlName="keyFactorWeight" required>
                    <mat-icon matSuffix [title]="getFieldErrorText('reviewPeriodPositionProfileSettings.keyFactorWeight')" class="text-danger" *ngIf="editForm.get('reviewPeriodPositionProfileSettings.keyFactorWeight').invalid && (editForm.get('reviewPeriodPositionProfileSettings.keyFactorWeight').touched || editForm.get('reviewPeriodPositionProfileSettings.keyFactorWeight').dirty)">error</mat-icon>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="flex-vertical col-box">
        <div formArrayName="questionSettings" class="settings-panel" *ngIf="assessmentActions && assessmentActions.questionModuleSettings && questionSettingsArray.controls.length > 0">
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.QUESTION_MODULE_SETTINGS' | translate }}
                <ng-container *ngIf="!allowSettingsEdit">
                    <ng-container *ngTemplateOutlet="reviewInProgressInfo"></ng-container>
                </ng-container>
            </div>
            <div class="panel-content simple-border">
                <div *ngFor="let child of questionSettingsArray.controls; let i = index">
                    <div class="settings-group" [formGroupName]="i">
                        <div class="group-title">{{ removeHtml(child.get("questionName").value) }}</div>
                        <mat-checkbox class="multiline" formControlName="isSelfAssessmentAllowed" [disableControl]="!allowSettingsEdit">{{ 'REVIEW_PERIOD_EDIT.SELF_ASSESSMENT' | translate }}</mat-checkbox>
                        <mat-checkbox class="multiline" formControlName="isLeaderAssessmentAllowed" [disableControl]="!allowSettingsEdit">{{ 'REVIEW_PERIOD_EDIT.SUBORDINATES_EVALUATE_LEADERS' | translate }}</mat-checkbox>
                        <mat-checkbox class="multiline" formControlName="isPeerAssessmentAllowed" [disableControl]="!allowSettingsEdit">{{ 'REVIEW_PERIOD_EDIT.PEERS_EVALUATE_EACH_OTHER' | translate }}</mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex-vertical col-box">
        <div *ngIf="isPanorama(selectedReviewType) && isGoalsEnabled" class="settings-panel">
            <app-review-period-custom-goals [items]="reviewPeriodCustomGoals"></app-review-period-custom-goals>
        </div>
    </div>

    <div class="flex-vertical col-box">

        <div *ngIf="isPanorama(selectedReviewType) && isGoalsEnabled" class="settings-panel" formGroupName="reviewPeriodGoalSettings">
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.GOAL_SETTINGS' | translate }}</div>
            
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.GOAL_SHEET_SETTINGS_EDIT' | translate }}</div>
            <div class="panel-content simple-border mb-3" >
                <div>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowSettingsForLeader">{{ 'REVIEW_PERIOD_EDIT.LEADER' | translate }}</mat-checkbox>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowSettingsForSelf">{{ 'REVIEW_PERIOD_EDIT.SELF' | translate }}</mat-checkbox>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowSettingsForAssistant">{{ 'REVIEW_PERIOD_EDIT.ASSISTANT' | translate }}</mat-checkbox>
                </div>
            </div>

            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.GOAL_DEADLINE_SETTINGS_EDIT' | translate }}</div>
            <div class="panel-content simple-border mb-3" >
                <div>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeDeadlineForLeader">{{ 'REVIEW_PERIOD_EDIT.LEADER' | translate }}</mat-checkbox>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeDeadlineForSelf">{{ 'REVIEW_PERIOD_EDIT.SELF' | translate }}</mat-checkbox>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeDeadlineForAssistant">{{ 'REVIEW_PERIOD_EDIT.ASSISTANT' | translate }}</mat-checkbox>
                </div>
            </div>

            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.CUSTOM_GOAL_WEIGHTS_EDIT' | translate }}</div>
            <div class="panel-content simple-border mb-3" >
                <div>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeWeightForLeader">{{ 'REVIEW_PERIOD_EDIT.LEADER' | translate }}</mat-checkbox>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeWeightForSelf">{{ 'REVIEW_PERIOD_EDIT.SELF' | translate }}</mat-checkbox>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeWeightForAssistant">{{ 'REVIEW_PERIOD_EDIT.ASSISTANT' | translate }}</mat-checkbox>
                </div>
            </div>

            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.GOAL_TEXT_EDIT' | translate }}</div>
            <div class="panel-content simple-border mb-3" >
                <div>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeGoalTextForLeader">{{ 'REVIEW_PERIOD_EDIT.LEADER' | translate }}</mat-checkbox>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeGoalTextForSelf">{{ 'REVIEW_PERIOD_EDIT.SELF' | translate }}</mat-checkbox>
                    <mat-checkbox class="multiline goalCheckbox" formControlName="isAllowChangeGoalTextForAssistant">{{ 'REVIEW_PERIOD_EDIT.ASSISTANT' | translate }}</mat-checkbox>
                </div>
            </div>


            <div>
                <mat-checkbox class="multiline goalCheckbox pb-2" formControlName="isTextBasedGoalsEnabled">{{ 'REVIEW_PERIOD_EDIT.TEXT_BASED_GOALS' | translate }}</mat-checkbox>
            </div>
            <div>
                <div class="panel-content p-top-only" >
                    <div class="flex-v">
                        <mat-form-field appearance="outline" class="flex-fill">
                            <mat-label>{{ 'REVIEW_PERIOD_EDIT.BLOCK_NAME_HU' | translate }}</mat-label>
                            <input matInput formControlName="textBasedGoalsBlockNameHu">
                        </mat-form-field>
            
                        <mat-form-field appearance="outline" class="flex-fill">
                            <mat-label>{{ 'REVIEW_PERIOD_EDIT.BLOCK_NAME_EN' | translate }}</mat-label>
                            <input matInput formControlName="textBasedGoalsBlockNameEn">
                        </mat-form-field>
                        
                        <mat-form-field appearance="outline">
                           <mat-label>{{ 'REVIEW_PERIOD_EDIT.DEFAULT_WEIGHT' | translate }}</mat-label>
                           <input matInput type="number" formControlName="textBasedGoalsDefaultWeight">
                        </mat-form-field>
                    </div>
                </div>
                
    
                <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.TEXT_GOALS_SLIDER_SETTINGS' | translate }}</div>
                <div class="panel-content goalsettings p-top-only">
                    <mat-form-field appearance="outline" [title]="'REVIEW_PERIOD_EDIT.MINIMUM_VALUE' | translate">
                        <mat-label>{{ 'REVIEW_PERIOD_EDIT.MINIMUM_VALUE' | translate }}</mat-label>
                        <input matInput type="text" formControlName="sliderMin" required>
                        <mat-icon matSuffix [title]="getFieldErrorText('reviewPeriodGoalSettings.sliderMin')" class="text-danger" *ngIf="editForm.get('reviewPeriodGoalSettings.sliderMin')?.invalid && (editForm.get('reviewPeriodGoalSettings.sliderMin')?.dirty || editForm.get('reviewPeriodGoalSettings.sliderMin')?.touched)">error</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" [title]="'REVIEW_PERIOD_EDIT.MAXIMUM_VALUE' | translate">
                        <mat-label>{{ 'REVIEW_PERIOD_EDIT.MAXIMUM_VALUE' | translate }}</mat-label>
                        <input matInput type="text" formControlName="sliderMax" required>
                        <mat-icon matSuffix [title]="getFieldErrorText('reviewPeriodGoalSettings.sliderMax')" class="text-danger" *ngIf="editForm.get('reviewPeriodGoalSettings.sliderMax')?.invalid && (editForm.get('reviewPeriodGoalSettings.sliderMax')?.dirty || editForm.get('reviewPeriodGoalSettings.sliderMax')?.touched)">error</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" [title]="'REVIEW_PERIOD_EDIT.STEP_SIZE' | translate">
                        <mat-label>{{ 'REVIEW_PERIOD_EDIT.STEP_SIZE' | translate }}</mat-label>
                        <input matInput type="text" formControlName="sliderStep" required>
                        <mat-icon matSuffix [title]="getFieldErrorText('reviewPeriodGoalSettings.sliderStep')" class="text-danger" *ngIf="editForm.get('reviewPeriodGoalSettings.sliderStep')?.invalid && (editForm.get('reviewPeriodGoalSettings.sliderStep')?.dirty || editForm.get('reviewPeriodGoalSettings.sliderStep')?.touched)">error</mat-icon>
                    </mat-form-field>
                </div>
            </div>


            <mat-divider class="mt-2 mb-3"></mat-divider>

            <!-- Numeric Goals -->
            <div>
                <mat-checkbox class="multiline goalCheckbox pb-2" formControlName="isNumericGoalsEnabled">{{ 'REVIEW_PERIOD_EDIT.NUMERIC_GOALS' | translate }}</mat-checkbox>
            </div>
            <div>
                <div class="panel-content p-top-only" > 
                    <div class="flex-v">
                        <mat-form-field appearance="outline" class="flex-fill">
                           <mat-label>{{ 'REVIEW_PERIOD_EDIT.BLOCK_NAME_HU' | translate }}</mat-label>
                           <input matInput formControlName="numericGoalsBlockNameHu">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="flex-fill">
                           <mat-label>{{ 'REVIEW_PERIOD_EDIT.BLOCK_NAME_EN' | translate }}</mat-label>
                           <input matInput formControlName="numericGoalsBlockNameEn">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="panel-content goalsettings p-top-only">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'REVIEW_PERIOD_EDIT.DEFAULT_WEIGHT' | translate }}</mat-label>
                    <input matInput type="number" formControlName="numericGoalsDefaultWeight">
                </mat-form-field>

                <mat-form-field appearance="outline" [title]="'REVIEW_PERIOD_EDIT.MAX_PERFORMANCE_PERCENT' | translate">
                    <mat-label>{{ 'REVIEW_PERIOD_EDIT.MAX_PERFORMANCE_PERCENT' | translate }}</mat-label>
                    <input matInput type="text" formControlName="numericGoalMaxResult" required>
                    <mat-icon matSuffix [title]="getFieldErrorText('reviewPeriodGoalSettings.numericGoalMaxResult')" class="text-danger" *ngIf="editForm.get('reviewPeriodGoalSettings.numericGoalMaxResult').invalid && (editForm.get('reviewPeriodGoalSettings.numericGoalMaxResult').dirty || editForm.get('reviewPeriodGoalSettings.numericGoalMaxResult').touched)">error</mat-icon>
                </mat-form-field>
            </div>

            <mat-divider class="mt-2 mb-3"></mat-divider>

            <!-- Group Goals -->
            <div class="panel-content goalsettings p-top-only">
                <mat-checkbox class="multiline goalCheckbox pb-2" formControlName="isGroupGoalsEnabled">{{ 'REVIEW_PERIOD_EDIT.GROUP_GOALS' | translate }}</mat-checkbox>
            </div>

            <mat-divider class="mt-2 mb-3"></mat-divider>

            <!-- Other settings -->
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.FORM_OPTIONS' | translate }}</div>
            <div class="panel-content simple-border" >
                <div>
                    <!-- Alapösszeg és Teljesítményösszeg elrejtése -->
                     <mat-checkbox class="multiline" formControlName="hiddenBaseAndPerformanceAmount">{{ 'REVIEW_PERIOD_EDIT.HIDE_BASE_AND_PERFORMANCE_AMOUNT' | translate }}</mat-checkbox>
        
                     <!-- Célkitűzés szerkesztésének letiltása az értékelteknek -->
                     <mat-checkbox class="multiline" formControlName="notAllowGoalChangesInFirstStateForSelf">{{ 'REVIEW_PERIOD_EDIT.NOT_ALLOW_GOAL_CHANGES_IN_FIRST_STATE_FOR_SELF' | translate }}</mat-checkbox>

                     <!-- Célkitűzés státusz inaktív -->
                     <mat-checkbox class="multiline" formControlName="firstStateDisabled">{{ 'REVIEW_PERIOD_EDIT.GOAL_SETTING_STATUS_INACTIVE' | translate }}</mat-checkbox>
                </div>
            </div>
        </div>
    
        <div class="settings-panel">
            <div class="panel-title">{{ 'REVIEW_PERIOD_EDIT.ASSESSMENT_STATUS' | translate }}</div>
            <div class="panel-content">
                <mat-form-field appearance="outline" class="settings-panel full-width">
                    <mat-label>{{ 'REVIEW_PERIOD_EDIT.STATUS' | translate }}</mat-label>
                    <mat-select formControlName="status" disableOptionCentering class="drop-fix" required>
                        <mat-option *ngFor="let status of statusList" [value]="status.id">{{ status.translateKey | translate }}</mat-option>
                    </mat-select>
                    <mat-error msg></mat-error>
                </mat-form-field>
            </div>
        </div>

        <div *ngIf="isDebug">
            EditForm invalid: {{ editForm.invalid }}<br>
            isGoalsEnabled: {{ isGoalsEnabled }}<br>
            isPositionBasedAssessment: {{ isPositionBasedAssessment }}<br>
            isAura: {{ isAura }}<br>
        </div>
        
    </div>
</div>

<div class="action-buttons flex-end">
    <button mat-flat-button color="primary" (click)="save()" [disabled]="editForm.invalid">{{ 'GENERAL.OK' | translate }}</button>
    <button mat-flat-button color="accent" (click)="cancel()">{{ 'GENERAL.CANCEL' | translate }}</button>
</div>

<ng-template #reviewInProgressInfo>
    <mat-icon [matTooltip]="'REVIEW_PERIOD_EDIT.SETTINGS_NOT_MODIFIABLE' | translate">error_outline</mat-icon>
</ng-template>
